import * as util from "./TimeUtils";

function range(str, {now = Date.now(), timezone = 0}= {}) {
    const timezoneOffset = timezone * 60 * 1000;
    const NOW = now;

    const timeToSpan = str => {
        let span = util.timeToSpan(str);

        if (span === null) {
            return null;
        }

        return {
            start: span.start + timezoneOffset,
            end: span.end + timezoneOffset
        };
    };

    if (!str) {
        return null;
    }

    try {
        str = str.trim().toLowerCase();

        if (str.indexOf("=") != -1) {
            let split = str.split("=");
            str = split.join("=");
        }

        if (str == "today") {
            str = "last 1 days";
        }

        const relativeMatch = str.match(/(?:this|last)\s*(\d+)?\s*(.+?)s?$/),
            quarterMatch = str.match(/(\d{4}-Q[1-4])(?:\s-\s)?(\d{4}-Q[1-4])?$/i);

        let start, end, what, match;

        if (relativeMatch) {
            const n = relativeMatch[1] != null ? relativeMatch[1] : 1;
            what = relativeMatch[2];

            let round = util.round(util.timeformats[what], timezone);
            start = round(util.increase[what](new Date(NOW), -1 * (n - 1))).getTime() + timezoneOffset;
            end = round(util.increase[what](new Date(NOW), 1)).getTime() + timezoneOffset;
        } else if (quarterMatch) {
            start = timeToSpan(quarterMatch[1]).start;
            end = quarterMatch[2] ? timeToSpan(quarterMatch[2]).end : timeToSpan(quarterMatch[1]).end;
        } else if (timeToSpan(str)) {
            let span = timeToSpan(str);
            [start, end] = [span.start, span.end];
        } else {
            match = str.match(/(.*) -\s?(.*)?/);
            start = timeToSpan(match[1]).start;
            end = match[2] ? timeToSpan(match[2]).end : Infinity;
        }

        if (!start || !end) {
            throw new Error("Failed to parse filter ", +str);
        }

        start = typeof start === "number" ? start : start.getTime();
        end = typeof end === "number" ? end : end.getTime();

        return [start, end];
    } catch (e) {
        return null;
    }
}

function parse(str, {timeKeys = null, ...rest}= {}) {
    let _range = range(str, rest);
    if (!_range) {
        return null;
    }

    let [start, end] = _range;
    return function(item) {
        return item.event.some(function(value, key) {
            if (timeKeys && timeKeys.indexOf(key) == -1) {
                return false;
            }
            const stamp = util.looseParseTime(value);
            return stamp && stamp >= start && stamp < end;
        });
    };
}

export default {parse, range};


// WEBPACK FOOTER //
// ./src/kpi/lib/TimeFilter.js